import { render, staticRenderFns } from "./app-footer.vue?vue&type=template&id=4cc78f3d&scoped=true&"
import script from "./app-footer.vue?vue&type=script&lang=js&"
export * from "./app-footer.vue?vue&type=script&lang=js&"
import style0 from "./app-footer.vue?vue&type=style&index=0&id=4cc78f3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc78f3d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc78f3d')) {
      api.createRecord('4cc78f3d', component.options)
    } else {
      api.reload('4cc78f3d', component.options)
    }
    module.hot.accept("./app-footer.vue?vue&type=template&id=4cc78f3d&scoped=true&", function () {
      api.rerender('4cc78f3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/layout/app-footer.vue"
export default component.exports